import { Footer } from 'armxlib'
import type { FooterLink } from 'armxlib'
import { en } from '../../i18n/en'
import { ROUTES } from '../../routes'

/** Links at the bottom of every page: terms, privacy and the contact address. */
export const FOOTER_LINKS: FooterLink[] = [
  { label: en.footer.terms, href: ROUTES.terms.path },
  { label: en.footer.privacy, href: ROUTES.privacy.path },
  { label: en.site.contact, href: `mailto:${en.site.contact}` },
]

/** The footer of the site. */
export function SiteFooter() {
  return <Footer links={FOOTER_LINKS} />
}
